import React from 'react';
import { useLanguage, useLocalizedNavigate } from '../contexts/LanguageContext';
import Header from '../components/Header';
import FooterMinimal from '../components/FooterMinimal';
import { useTranslations } from '../translations/translations';

const TrainingPage = () => {
  const navigate = useLocalizedNavigate();
  const { language } = useLanguage();
  const t = useTranslations();

  return (
    <div className="App">
      <Header />
      <main style={{ background: '#000', minHeight: '100vh', paddingTop: '80px' }}>
        <section style={{
          padding: '8rem 0 4rem',
          borderBottom: '1px solid #1a1a1a'
        }}>
          <div className="container-custom">
            <button
              onClick={() => navigate('/')}
              style={{
                background: 'transparent',
                border: '1px solid #262626',
                color: '#a3a3a3',
                padding: '0.75rem 1.5rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                marginBottom: '3rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#404040';
                e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#262626';
                e.currentTarget.style.color = '#a3a3a3';
              }}
            >
              ← {language === 'fr' ? 'Retour' : 'Back'}
            </button>

            <div style={{
              fontSize: '0.8rem',
              letterSpacing: '3px',
              color: '#525252',
              marginBottom: '1.5rem',
              fontWeight: 500
            }}>
              SERVICE 05
            </div>

            <h1 style={{
              fontSize: 'clamp(1.9rem, 10vw, 4.5rem)',
              fontWeight: 300,
              marginBottom: '1rem',
              letterSpacing: '-0.02em',
              color: '#fff'
            }}>
              {t.formation.title}
            </h1>

            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: 400,
              marginBottom: '3rem',
              color: '#a3a3a3'
            }}>
              {t.formation.subtitle}
            </h2>

            <p style={{
              fontSize: '1.1rem',
              color: '#737373',
              lineHeight: 1.8,
              maxWidth: '900px',
              fontWeight: 300
            }}>
              {t.formation.intro}
            </p>

            <a 
              href="https://sf3pro.fr/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginTop: '2rem',
                padding: '1rem 2rem',
                background: 'transparent',
                border: '1px solid #404040',
                borderRadius: '4px',
                color: '#fff',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: 500,
                letterSpacing: '0.5px',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#fff';
                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#404040';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              → {language === 'fr' ? 'Visitez SF3 Pro' : 'Visit SF3 Pro'}
            </a>

            <div style={{
              marginTop: '3rem',
              padding: '1.5rem 2rem',
              background: '#0a0a0a',
              border: '1px solid #262626',
              borderRadius: '8px',
              display: 'inline-block'
            }}>
              <div style={{
                fontSize: '0.9rem',
                fontWeight: 600,
                letterSpacing: '1px',
                color: '#fff'
              }}>
                🎓 {language === 'fr' ? 'Certifié SF3 Pro' : 'Certified by SF3 Pro'}
              </div>
            </div>
          </div>
        </section>

        <section style={{
          padding: '6rem 0',
          borderBottom: '1px solid #1a1a1a'
        }}>
          <div className="container-custom">
            <div style={{
              width: '100%',
              height: '700px',
              borderRadius: '8px',
              overflow: 'hidden',
              border: '1px solid #262626',
              position: 'relative',
              background: '#000'
            }}>
              <img 
                src="/images/altes/formation-sf3.jpg"
                alt="Formation SF3 Pro - ALTES Protection"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                  filter: 'grayscale(100%)'
                }}
              />
            </div>
          </div>
        </section>

        <section style={{
          padding: '6rem 0'
        }}>
          <div className="container-custom">
            <div style={{
              maxWidth: '1200px'
            }}>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: '1.5rem',
                color: '#fff'
              }}>
                {t.formation.standards.title}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#737373',
                lineHeight: 1.8,
                fontWeight: 300,
                marginBottom: '4rem'
              }}>
                {t.formation.standards.text}
              </p>

              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: '1.5rem',
                color: '#fff'
              }}>
                {t.formation.preparation.title}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#737373',
                lineHeight: 1.8,
                fontWeight: 300,
                marginBottom: '4rem'
              }}>
                {t.formation.preparation.text}
              </p>

              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: '1.5rem',
                color: '#fff'
              }}>
                {t.formation.continue.title}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#737373',
                lineHeight: 1.8,
                fontWeight: 300,
                marginBottom: '4rem'
              }}>
                {t.formation.continue.text}
              </p>

              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: '1.5rem',
                color: '#fff'
              }}>
                {t.formation.partenariats.title}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#737373',
                lineHeight: 1.8,
                fontWeight: 300,
                marginBottom: '2rem'
              }}>
                {t.formation.partenariats.text}
              </p>

              <a 
                href="https://sf3pro.fr/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '1rem 2rem',
                  background: 'transparent',
                  border: '1px solid #404040',
                  borderRadius: '4px',
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  letterSpacing: '0.5px',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = '#fff';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = '#404040';
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                → {language === 'fr' ? 'Visitez SF3 Pro' : 'Visit SF3 Pro'}
              </a>
            </div>
          </div>
        </section>
      </main>
      <FooterMinimal />
    </div>
  );
};

export default TrainingPage;